import { Card } from 'primereact/card';
import TeacherDashboardDiagnosticWidgetEmpty from '../Diagnostic/TeacherDashboardDiagnosticWidgetEmpty';

const TeacherDashboardDiagnosticEmptyWrapper = () => {
  return (
    <Card
      className="tw-h-full nc_block tw-p-0 tw-my-4 !tw-shadow-none !tw-border-indigo-200"
      header={() => (
        <h2 className="tw-text-lg tw-p-2 tw-font-bold tw-not-italic tw-border-b-[2px] tw-border-t-[0px] tw-border-x-[0px] tw-border-neutral-100 tw-border-solid">
          Diagnostic
        </h2>
      )}
    >
      <TeacherDashboardDiagnosticWidgetEmpty />
    </Card>
  );
};

export default TeacherDashboardDiagnosticEmptyWrapper;
